/**
 * Represents a filter object that can be sent to the API
 */
export type FilterObject = {
  filterKey: string;
  filterType: string;
  filterValues: (string | number | boolean)[];
};

/**
 * Generic filter options type where each key maps to a possible filter value
 */
export type FilterOptions<T extends Record<string, unknown>> = {
  [K in keyof T]?: T[K];
};

/**
 * Configuration for mapping filter options to FilterObjects
 */
export type FilterConfig<T extends Record<string, unknown>> = {
  [K in keyof T]: {
    filterKey: string;
    filterType: string;
    mapToValues: (value: NonNullable<T[K]>) => (string | number | boolean)[];
  };
};

/**
 * Filter types supported by the API
 */
export enum FilterType {
  INCLUDING = 'including',
  EXCLUDING = 'excluding',
  ARRAY_INCLUDING = 'array-including',
}
